import axios from "../utils/axios";

export default function fetchOrders(adminId, params) {
  return axios.get("/admin/" + adminId + "/orders", { params });
}
